import Chip from '@mui/material/Chip';
import Grid from '@mui/material/Grid';
import styles from './styles.module.css';

const ScrollableChips = ({ values, onClick, selected }) => {
    return (
        <Grid>
            <div className={styles.scroll}>
                {values.map((v) => {
                    return (
                        <Chip
                            key={v.id}
                            component='div'
                            sx={{
                                fontSize: '14px',
                                mx: 0.5,
                                ...(v.name == values?.[0]?.name && {
                                    ml: 2,
                                }),
                                ...(v.name == values[values.length - 1].name && {
                                    mr: 2,
                                }),
                                zIndex: 1,
                            }}
                            label={v.name}
                            variant={v.name !== (selected && selected.name) ? 'outlined' : 'filled'}
                            onClick={() => onClick(v)}
                        />
                    );
                })}
            </div>
        </Grid>
    );
};

export default ScrollableChips;
